import { render, staticRenderFns } from "./RoomExtraPersonPriceList.vue?vue&type=template&id=1b0fadca&"
import script from "./RoomExtraPersonPriceList.vue?vue&type=script&lang=js&"
export * from "./RoomExtraPersonPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports